import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RubroService } from 'src/app/services/rubro.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RubroModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';

@Component({
  selector: 'app-rubro',
  templateUrl: './rubro.component.html',
  styleUrls: ['./rubro.component.scss'],
  providers: [SecurityService],
})
export class RubroComponent implements OnInit {

  @ViewChild(RubroModalAddEditComponent, { static: true }) modalAddEditRubro: RubroModalAddEditComponent
  // Form
  formHeader: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  listaRubros: Array<any> = null
  inputParams: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loadAll: boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private rubroService: RubroService
  ) { }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())

    this.paginationContext.RecordsByPage = 10
    //this.loadOperaciones()
    this.loadData()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      descripcion: [''],
    });
  }

  openModalRubro() {
    this.modalAddEditRubro.show()
  }

  loadData() {
    this.listaRubros = null
    this.paginationContext.CurrentPage = 1
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        descripcion: this.formHeader.get('descripcion').value
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
    this.inputParams = inputParams
    this.loadAll = true
    this.buscar()
  }

  buscar() {
    this.inputParams.paginaActual = this.paginationContext.CurrentPage
    this.rubroService.obtenerSegunFiltro(this.inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.renderResults(respuesta)
    })
  }

  renderResults({ registros, paginaActual, totalPaginas, totalRegistros }) {
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.listaRubros = registros
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  editar(rubro) {
    this.modalAddEditRubro.load(rubro)
  }

  onAddEdit(rubro) {
    this.loadData()
  }

  desactivar({ codigo, empresa_rut }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        activo: false
      }
    }
    this.cambiarEstado(inputParams)
  }

  activar({ codigo, empresa_rut }) {
    const inputParams = {
      entidad: {
        codigo,
        empresa_rut,
        activo: true
      }
    }
    this.cambiarEstado(inputParams)
  }

  cambiarEstado(inputParams) {
    this.rubroService.cambiaEstado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.buscar()
    })
  }
}
